import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import {
   Card, CardBody, Row, Col
} from 'reactstrap';
import { TextField } from '../../../shared/TextField';
import { UserSearchAutocomplete } from '../../../shared/UserSearchAutocomplete';
import { ListUsersWithCertificate } from './ListUsersWithCertificate';
import { PRODUCT_GROUPS } from '../../../../config/constants';
import {
  calculateTotalPriceOnCustomOrderWithoutVat, getCustomOrderProduct
} from '../../../../helpers/general';
import { ErrorMessage } from 'formik';
import { Messages } from '../../../layout/Messages/Messages';

function CertificateWithAuthFields(props) {
  const [ userWithCertificate, setUserWithCertificate ] = useState( [] );
  const [ userWithOutCertificate, setUserWithOutCertificate ] = useState( props.users );

  useEffect( () => {
    // When list of users is changed(organization is changed)
    setUserWithOutCertificate( props.users );
    setUserWithCertificate( [] );
    props.formikProps.setFieldValue( 'usersWithCertificateWithAuth', [] );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ props.users ] );

  const getCurrencyOfProduct = () => {
    let productGroup;
    props.productGroups.forEach( item => {
      if (item.name === PRODUCT_GROUPS.CERTIFICATE_WITH_AUTH.name) {
        productGroup = item;
      }
    } );

    return getCustomOrderProduct(productGroup).currency;
  }

  const calculateTotalPrice = () => {
    if (isNaN( props.formikProps.values.certificatesWithAuthNumber ) || isNaN( props.formikProps.values.certificatesWithAuthValue )) {
      return `0 ${getCurrencyOfProduct()}`;
    }

    return `${calculateTotalPriceOnCustomOrderWithoutVat( props.formikProps.values.certificatesWithAuthNumber, props.formikProps.values.certificatesWithAuthValue )} ${getCurrencyOfProduct()}`
  }

  const getIndexOfUser = (data, user) => {
    let i = -1;
    data.forEach( (item, index) => {
      if (item.id === user.id) {
        i = index;
      }
    } );

    return i;
  }

  const assignCertificateToUser = (user) => {
    let cloneOfUserWithCertificate = [ ...userWithCertificate ];
    let cloneUserWithoutCertificate = [ ...userWithOutCertificate ];
    cloneOfUserWithCertificate.push( user );
    cloneUserWithoutCertificate.splice( getIndexOfUser( cloneUserWithoutCertificate, user ), 1 );

    setUserWithCertificate( cloneOfUserWithCertificate );
    setUserWithOutCertificate( cloneUserWithoutCertificate );
    props.formikProps.setFieldValue( 'usersWithCertificateWithAuth', cloneOfUserWithCertificate );
  }

  const removeCertificateFromUser = (user) => {
    let cloneOfUserWithCertificate = [ ...userWithCertificate ];
    let cloneOfUserWithOutCertificate = [ ...userWithOutCertificate ];

    cloneOfUserWithCertificate.splice( getIndexOfUser( cloneOfUserWithCertificate, user ), 1 );
    cloneOfUserWithOutCertificate.push( user );

    setUserWithOutCertificate( cloneOfUserWithOutCertificate );
    setUserWithCertificate( cloneOfUserWithCertificate );
    props.formikProps.setFieldValue( 'usersWithCertificateWithAuth', cloneOfUserWithCertificate );
  }

  return (
    <Card id="certificates-with-auth-content">
      <CardBody>
        {props.organization ? <>
          <Row className="align-items-center mb-3">
            <Col xs={12} sm={3}>
              <FormattedMessage
                id="components.pages.orderManagement.selectProductGroup.certificates.number"/>
            </Col>
            <Col xs={12} sm={9}>
              <TextField
                name="create_order.number"
                value={props.formikProps.values.certificatesWithAuthNumber}
                classNameFormGroup="m-0"
                onChange={(e) =>
                  props.formikProps.setFieldValue( "certificatesWithAuthNumber", e.target.value )
                }
                errorClass={props.getErrorClass( props.formikProps, 'certificatesWithAuthNumber' )}
              />
              <Messages
                color="danger"
                formikProps={props.formikProps}
                class="small-field-error"
                showDismiss={false}
              >
                <ErrorMessage
                  name="certificatesWithAuthNumber"
                  component="div"
                  data-testid="errors-certificatesWithAuthNumber"
                  className="field-error"
                />
              </Messages>
            </Col>
          </Row>
          <Row className="align-items-center mb-3">
            <Col xs={12} sm={3}>
              <FormattedMessage
                id="components.pages.orderManagement.selectProductGroup.simple_signatures.price"/>
            </Col>
            <Col xs={12} sm={9}>
              <TextField
                name="create_order.value"
                value={props.formikProps.values.certificatesWithAuthValue}
                classNameFormGroup="m-0"
                onChange={(e) =>
                  props.formikProps.setFieldValue( "certificatesWithAuthValue", e.target.value )
                }
                errorClass={props.getErrorClass( props.formikProps, 'certificatesWithAuthValue' )}
              />
              <Messages
                color="danger"
                formikProps={props.formikProps}
                class="small-field-error"
                showDismiss={false}
              >
                <ErrorMessage
                  name="certificatesWithAuthValue"
                  component="div"
                  data-testid="errors-certificatesWithAuthValue"
                  className="field-error"
                />
              </Messages>
            </Col>
          </Row>
          <Row className="align-items-center mb-3">
            <Col xs={12} sm={3}>
              <FormattedMessage
                id="components.pages.orderManagement.createOrderForm.select_user_for_certificate"/>
            </Col>
            <Col xs={12} sm={9}>
              <UserSearchAutocomplete
                data={userWithOutCertificate}
                errorClass={props.getErrorClass( props.formikProps, 'usersWithCertificateWithAuth' )}
                onSelect={assignCertificateToUser}/>
              <Messages
                color="danger"
                formikProps={props.formikProps}
                class="small-field-error"
                showDismiss={false}
              >
                <ErrorMessage
                  name="usersWithCertificateWithAuth"
                  component="div"
                  data-testid="errors-usersWithCertificateWithAuth"
                  className="field-error"
                />
              </Messages>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center mb-3">
            <Col xs={12} sm={9}>
              <ListUsersWithCertificate
                users={userWithCertificate}
                removeCertificateFromUser={removeCertificateFromUser}
              />
            </Col>
          </Row>
        </> : <div className="select-organization-error">
          <FormattedMessage
            id="components.pages.orderManagement.createOrderForm.select_organization"/>
        </div>}
        {props.organization && <Row className="create-order-total-val">
          <FormattedMessage
            id="components.pages.orderManagement.selectProductGroup.simple_signatures.sub_total"/> {calculateTotalPrice()}
        </Row>}
      </CardBody>
    </Card>
  );
};


export { CertificateWithAuthFields };
